import { storage } from '@/plugins/firebase';

export async function uploadPhoto(photoPath, photoFile) {
  const storageRef = storage.ref().child(photoPath);

  try {
    const uploadTaskSnapshot = await storageRef.put(photoFile);
    return await uploadTaskSnapshot.ref.getDownloadURL();
  } catch (err) {
    console.error(err);
    return '';
  }
}

export async function deletePhoto(photoPath, photoFile) {
  //TODO: implement this function
  console.log(photoPath);
  console.log(photoFile);
}
